// extracted by css-extract-rspack-plugin
export default {"Item":"Selector-module__Item__NDNbD","Overlay":"Selector-module__Overlay__C01fe","LegacyOverlay":"Selector-module__LegacyOverlay__eXiyB"};